var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agileits_w3layouts-footer"},[_c('p',[_vm._v("© 2020 abhiram.info. All rights reserved.")])])}]

export { render, staticRenderFns }